"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-Star" },
      _react2.default.createElement("path", { d: "M9.241.3L11.4 6.015l6.106.289a.255.255 0 0 1 .147.454l-4.77 3.823 1.612 5.9a.255.255 0 0 1-.386.28L9 13.4l-5.11 3.358a.255.255 0 0 1-.386-.28l1.612-5.9L.348 6.757A.255.255 0 0 1 .5 6.3l6.1-.285L8.763.3a.255.255 0 0 1 .478 0z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M11.361 1.68l2.259 5.975a.257.257 0 0 0 .228.166l6.381.3a.386.386 0 0 1 .223.686L15.467 12.8a.256.256 0 0 0-.087.268l1.684 6.162a.386.386 0 0 1-.584.424l-5.34-3.506a.258.258 0 0 0-.282 0l-5.34 3.506a.386.386 0 0 1-.584-.424l1.686-6.158a.256.256 0 0 0-.087-.268l-4.985-4a.386.386 0 0 1 .223-.686l6.381-.3a.257.257 0 0 0 .228-.166l2.259-5.972a.386.386 0 0 1 .722 0z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'Star';
exports.default = WrappedIcon;

